import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { Observable, Subject, Subscription, of } from 'rxjs';
import { CookieService } from 'src/app/customServices/cookie.service';
import { KbGetAQuoteService } from './kb-get-aquote.service';
import { NgIfAnimation } from './ngIfAnimation';
import { QuotePopupComponent } from './quote-popup/quote-popup.component';
import { KBLanguageService } from 'src/app/services/sapSpartacus/kbLanguageService/KbLang-service.service';
import { takeUntil } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-kb-get-aquote',
    templateUrl: './kb-get-aquote.component.html',
    styleUrls: ['./kb-get-aquote.component.scss'],
    animations: [NgIfAnimation],
    standalone: false
})
export class KbGetAQuoteComponent {
  private service = inject(KbGetAQuoteService);
  private activatedRoute = inject(ActivatedRoute);
  private matDialog = inject(MatDialog);
  private breakPointObserver = inject(BreakpointObserver);
  private translateService = inject(TranslationService);
  private cdr = inject(ChangeDetectorRef);
  private cookieService = inject(CookieService);
  private globalMsgservice = inject(GlobalMessageService);
  private router = inject(Router);
  private langService = inject(KBLanguageService);

  key: string = 'common.saved_quote_total_number';
  translatedValue: string = '';
  quoteData$: Observable<any>;
  toptoggle = true;
  bottomtoggle = false;
  quoteCode: string = '';
  isMobile: boolean = false;
  isSubmitted: boolean = false;
  private subslang: Subscription;
  private unsubscribe$ = new Subject<void>();
  private avoidPageLoadCall: boolean = false;
  platformId = inject(PLATFORM_ID); 
  quoteForm = new FormGroup({
    quoteName: new FormControl(),
    description: new FormControl(),
    comment: new FormControl(),
  });

  ngOnInit() {
    this.avoidPageLoadCall = false;
    this.breakPointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.unsubscribe$))
      .subscribe(result => {
        this.isMobile = result.matches;
      });
    this.translateService.translate(this.key).pipe(takeUntil(this.unsubscribe$)).subscribe((returnedString: string) => {
      this.translatedValue = returnedString;
    })
    this.activatedRoute.queryParamMap.pipe(takeUntil(this.unsubscribe$)).subscribe((params) => {
      this.quoteCode = params.get('code');
      if (this.quoteCode) {
        this.apiCaller();
      }
    });
  }

  ngAfterViewInit() {
    this.subslang = this.langService.getActive().pipe(takeUntil(this.unsubscribe$)).subscribe((lang) => {
      if (this.avoidPageLoadCall) {
        this.apiCaller();
      }
    });
  }

  initiateFormFromService() {
    this.quoteForm.controls.quoteName.setValue(this.service.stateMaintenance?.quoteName ?? this.quoteCode);
    this.quoteForm.controls.description.setValue(this.service.stateMaintenance?.description ?? '');
    this.quoteForm.controls.comment.setValue(this.service.stateMaintenance?.comment ?? '');
  }

  apiCaller() {
    this.service.getDataWithQuoteId(this.quoteCode).pipe(takeUntil(this.unsubscribe$)).subscribe((apires: any) => {
      this.translatedValue = this.translatedValue.replace('{0}', apires?.quoteCount ?? 0);
      this.initiateFormFromService();
      this.quoteForm.controls.quoteName.setValue(apires?.name);
      this.quoteData$ = of(apires);
      this.avoidPageLoadCall = true;
      this.cdr.detectChanges();
    });
  }
  goBack() {
    if (isPlatformBrowser(this.platformId)) {
    window.history.back();
    }
  }
  openDialogBox(isSubmit: boolean) {
    const data = {
      description: this.quoteForm.controls.description.value ?? '',
      name: this.quoteForm.controls.quoteName.value ?? '',
      comment: this.quoteForm.controls.comment.value ?? '',
      id: this.quoteCode,
      calledBy: ''
    };

    if (isSubmit) {
      data.calledBy = 'SUBMITFROMEDIT';
    } else {
      data.calledBy = 'CANCELFROMEDIT';
    }
    this.service.popUpCaller = data;
    const dialogRef = this.matDialog.open(QuotePopupComponent, { maxWidth: '440px', });
    dialogRef.afterClosed().pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {

      if (this.service.yes && (data.calledBy == 'SUBMITFROMEDIT')) {
        this.service.submitQuote(this.quoteCode, this.quoteForm.value).pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
          this.afterPopupClosed(res?.msg);
        });
      } else if (this.service.yes && (data.calledBy == 'CANCELFROMEDIT')) {
        this.service.cancelQuote(this.quoteCode).pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
          this.translateService.translate(res?.message).pipe(takeUntil(this.unsubscribe$)).subscribe((translated: string) => {
            this.service.cancelMsg = true;
            this.afterPopupClosed(translated.replace('{0}', res?.errorValue1));
          })

        });
      }
    });
  }

  afterPopupClosed(msg) {
    const custId = this.cookieService.getCookieValue('customerIdNA');
    this.cookieService.removeItemSessionStorage(custId);
    this.service.globalMsg = msg;
    this.router.navigateByUrl('/my-quotes');
  }

  removeProduct(entryNumber) {
    this.service.removeProductFromQuote(entryNumber, this.quoteCode).pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      if (res?.status == 'SUCCESS') {
        this.globalMsgservice.add({ key: res.message }, GlobalMessageType.MSG_TYPE_INFO);
        this.apiCaller();
      }
    })
  }

  ngOnDestroy() {
    this.service.yes = false;
    this.service.stateMaintenance = this.quoteForm.value;
    this.subslang && this.subslang.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
